(ns ycweb.app.website.myaccount.wishlist.wishlist
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as cart.model]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

;; LIST ================================================================================================================
(rum/defc wishlist-line < rum/reactive cmn/cursors [app-atom wishlist-item]
  (let [state-atom (cmn/action-cursor app-atom)
        notify-atom (rum/cursor-in state-atom [:notify-items (:ent/uuid wishlist-item) :wishlist-item/notify])
        notify (rum/react notify-atom)

        {:wishlist-item/keys [deleted?]
         :item-line/keys [variation product]} wishlist-item

        {:variation/keys
         [discontinued? features pack-description display-pack-size code
          in-stock? price selling-pack-size price-was]} variation

        {:product/keys [link]} product

        new-cart-enabled
        (cmn/curact app-atom [:features :new-cart])]
    (if deleted?
      [:tr.yc-tr
       [:td
        {:class (u/bem :yc-td [:flush])
         :colSpan 5}
        [:div
         {:class (u/bem :feedback [:flush :warning])}
         [:div.feedback__icon
          [:i {:class (u/bem :icon [:inline :warning])}]]
         [:div.feedback__message
          (str
            "You removed " (:ent/display-name product) ". ")
          [:a.text-link
           {:on-click
            #(grid/dispatch-action app-atom :web.myaccount.wishlist/undo-remove
               {:item {:ent/uuid (:ent/uuid wishlist-item)}})} "Undo?"]]]]]

      [:tr.yc-tr
       (when (and (not in-stock?) discontinued?)
         {:class "yc-tr--warning"})
       [:td
        {:class (u/bem :yc-td [:product-image])}
        (when (not-empty (:doc/public-id (:ent/image variation)))
          [:a {:href link}
           [:img.yc-td__image {:src (u/cloudinary (:doc/public-id (:ent/image variation)) {:w 100 :h 100 :c "pad"})}]])]
       [:td.yc-td.yc-td--product-text
        [:a.block-link {:href link}
         [:div.yc-td__product-name (:ent/display-name product)]
         [:div.yc-td__product-description
          features
          (when (> display-pack-size 1)
            (str pack-description " of " display-pack-size (when (not-empty features) ", ")))
          (when (or (not-empty features) (> display-pack-size 1)) [:span.u-pipe " | "])
          (str "Product Code: " code)]
         (when (and (not in-stock?) (not discontinued?))
           [:div.yc-td__product-notes
            [:span
             {:class (u/bem :text-status [:error])}
             "This item is awaiting stock."]])]]
       [:td.yc-td
        (when-not (and discontinued? (pos? price) (not in-stock?))
          (let [on-special? (and price-was (pos? price-was) (> price-was price))]
            [:span.yc-td__faux-table {:data-th "Price"}
             (when on-special?
               [:span.yc-td__faux-td.product-was-price (str "R" (u/currency-format price-was))])
             [:span.yc-td__faux-td
              {:class (when on-special? "u-text-red u-text-bold")}
              (str "R" (u/currency-format (* price (or selling-pack-size 1)) 0))]]))]
       [:td.yc-td.yc-td--centered
        (if (and (> price 0) in-stock?)
          [:span.yc-td__faux-table {:data-th "Move"}
           [:span.yc-td__faux-td
            [:a.text-link
             {:href "#"
              :on-click
              (fn [e]
                (.preventDefault e)
                (cond
                  new-cart-enabled
                  (do
                    (toaster/open-toast app-atom :processing "Adding item to cart" {})
                    (cart.model/add-to-cart app-atom
                      {:variation_uuid (str (:ent/uuid variation))
                       :qty (or selling-pack-size 1)
                       :addsource "wishlist"}
                      (fn [response]
                        (toaster/close-toast app-atom)
                        (cart.model/open-add-to-cart-modal app-atom response
                          :variation_uuid (str (:ent/uuid variation))))))

                  :else
                  #?(:clj nil
                     :cljs
                     (js/addToCartSPA
                       (clj->js
                         {:contentid (:product/id product)
                          :variationid (:variation/id variation)
                          :qty (or selling-pack-size 1)})))))}
             "Add to Cart"]
            [:span.u-pipe "|"]
            [:a.text-link
             {:href "#"
              :on-click
              (fn [e]
                (.preventDefault e)

                #?(:clj nil
                   :cljs
                   (js/addToRegistrySPA
                     (clj->js
                       {:contentid (:product/id product)
                        :variationid (:variation/id variation)
                        :qty (or selling-pack-size 1)}))))}
             "Add to Registry"]]]

          (if discontinued?
            [:b.text-status--warning "Discontinued"]
            [:label.toggle-label
             {:for (str "notify-" (:ent/uuid wishlist-item))}
             [:input.toggle.js-mc-interest-toggle
              (merge
                (input-forms/checkbox-props
                  notify-atom
                  #(grid/dispatch-action app-atom :web.myaccount.wishlist/notify-me
                     {:variation {:ent/uuid (:ent/uuid variation)}
                      :notify (not notify)})
                  nil
                  false
                  false)
                {:id (str "notify-" (:ent/uuid wishlist-item))})]
             [:span.toggle__graphic-wrapper
              [:span.toggle__graphic]]
             [:span.toggle__text
              [:span.toggle__title.toggle__title--small "Notify me when in stock"]]]))]
       [:td
        {:class (u/bem :yc-td [:centered])}
        [:span.yc-td__faux-table {:data-th "Options"}
         [:span.yc-td__faux-td

          [:a
           {:on-click #(grid/dispatch-action app-atom :web.myaccount.wishlist/remove {:item {:ent/uuid (:ent/uuid wishlist-item)}})
            :class (u/bem :icon-link :icon-block-link [:size-small] :tooltip [:top])
            :data-tooltip "Remove"}
           [:i {:class (u/bem :icon [:delete :is-dark :inline])}]]]]]])))

(rum/defc wishlist-table [app-atom wishlist-items]
  [:table
   {:class (u/bem :yc-table [:order-view]) :id :wishlistlist}
   [:caption.yc-table-caption.hidden-from-view
    "View items that have been added to your Wish List"]
   [:colgroup
    [:col {:style {:width "100px"}}]
    [:col]
    [:col]
    [:col]
    [:col]]
   [:thead.yc-thead
    [:tr.yc-tr
     [:th.yc-th {:scope "col"} "Item"]
     [:th.yc-th {:scope "col"} "Description"]
     [:th.yc-th {:scope "col"} "Price"]
     [:th.yc-th.yc-th--centered
      {:class (u/bem :yc-th [:centered])
       :scope "col"}
      "Move items"]
     [:th
      {:class (u/bem :yc-th [:centered])
       :scope "col"}
      "Options"]]]

   (into
     [:tbody.yc-tbody]
     (map (partial wishlist-line app-atom) wishlist-items))])

(rum/defc wishlist < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        wishlist-items (cmn/curact action-atom [:wishlist-items])
        wishlistlist-settings (rum/cursor-in app-atom [:myaccount :wishlist-list])
        {:keys [pages]} (rum/react wishlistlist-settings)
        pagecount (u/ceil (/ (count wishlist-items) (:pagesize pages 10)))]

    (when (> (or (:page pages) 0) pagecount)
      (swap! wishlistlist-settings assoc-in [:pages :page] 1))

    [:div.dashboard
     (headings/heading "Wish List" {:type :h2 :size :medium})

     (cond
       (not-empty wishlist-items)
       (list
         (wishlist-table app-atom
           (->>
             wishlist-items
             (drop (* (- (:page pages 1) 1) (:pagesize pages 10)))
             (take (:pagesize pages 10))))
         (web-common/pagination-control app-atom (rum/cursor wishlistlist-settings :pages) pagecount {:scroll-to "wishlistlist"}))

       :else
       [:div
        {:class (u/bem :no-data-wrapper :yc-section [:standard])}
        [:div.no-data-view
         [:p "You don't have items on your Wish List."]
         [:div
          {:class (u/bem :button-wrapper [:align-center])}
          (buttons/button-web "Start browsing"
            {:href "/products.htm"
             :style :dark})]]])
     (toaster/loading-overlay app-atom :web.myaccount/wishlist)]))

(defmethod flow/render-screen :web.myaccount/wishlist [app-atom _]
  (awm.common/screen-wrapper app-atom
    (wishlist app-atom)))

(defmethod t/transition-open :web.myaccount/wishlist [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/wishlist)
  (comms/ajax-get :web.myaccount/wishlist {}))

(defmethod comms/receive :web.myaccount/wishlist [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/wishlist)
  (swap! (cmn/action-cursor app-atom) assoc
    :wishlist-items (:wishlist-items e)
    :notify-items (:notify-items e)))

;; NOTIFY ==============================================================================================================
(defmethod grid/action :web.myaccount.wishlist/notify-me [app-atom config _]
  (toaster/open-toast app-atom :processing "Updating" {:closetime 10000})
  (comms/ajax-post :web.myaccount/wishlistnotify config))

(defmethod comms/receive :web.myaccount/wishlistnotify [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000}))

;; DELETE ==============================================================================================================

(defn update-deleted-items [app-atom e]
  (->>
    (get-in @app-atom [:web.myaccount/wishlist :wishlist-items])
    (map
      (fn [item]
        (if (= (:ent/uuid item) (:ent/uuid (:item e)))
          (assoc item
            :wishlist-item/dateDeleted (:item/date-deleted (:item e))
            :wishlist-item/deleted? (:item/deleted? (:item e)))
          item)))))

(defmethod grid/action :web.myaccount.wishlist/remove [app-atom config _]
  (comms/ajax-post :web.myaccount/wishlistremove config))

(defmethod comms/receive :web.myaccount/wishlistremove [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc :wishlist-items (update-deleted-items app-atom e)))

;; UNDO ================================================================================================================
(defmethod grid/action :web.myaccount.wishlist/undo-remove [app-atom config _]
  (comms/ajax-post :web.myaccount/wishlistundoremove config))

(defmethod comms/receive :web.myaccount/wishlistundoremove [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc :wishlist-items (update-deleted-items app-atom e)))
